export function fmtDate(d) {
  if (!d) return '-';
  const parts = d.split('T')[0].split('-');
  if (parts.length !== 3) return d;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function fmtDateTime(d) {
  if (!d) return '-';
  try {
    const dt = new Date(d);
    // Formatta sempre in fuso orario Europe/Rome
    const parts = new Intl.DateTimeFormat('it-IT', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
      timeZone: 'Europe/Rome'
    }).formatToParts(dt);
    const get = (t) => parts.find(p => p.type === t)?.value || '';
    return `${get('day')}/${get('month')}/${get('year')} ${get('hour')}:${get('minute')}`;
  } catch {
    return d;
  }
}
